import { StyledLogo, SvgLogo } from './Logo.styles';
import React from 'react';
export const Logo = (props) => {
    const svgProps = {
        width: props?.width,
        height: props?.height,
        x: props?.x,
        y: props?.y,
    };
    return (React.createElement(React.Fragment, null, props.src && (React.createElement(StyledLogo, null,
        React.createElement(SvgLogo, { ...svgProps }, props.src)))));
};
